import createEnum from 'lib/createEnum';

export const CONFIG_CHAT_THROTTLED = 'ui/CONFIG_CHAT_THROTTLED';
export const CONFIG_FETCH = 'configuration/FETCH';
export const CONFIG_UPDATE = 'configuration/UPDATE';
export const CONFIG_FETCH_ERROR = 'configuration/FETCH_ERROR';
export const CONFIG_OFFICE_CLOSED = 'ui/CONFIG_OFFICE_CLOSED';
export const CONFIG_REFRESH_SUCCESS = 'config/REFRESH_SUCCESS';
export const PROACTIVE_TRIGGERED = 'config/PROACTIVE_TRIGGERED';
export const SET_WELCOME_MESSAGE = 'config/SET_WELCOME_MESSAGE';

export const ALIGNMENTS = createEnum('LEFT', 'RIGHT');
export const BORDER_RADII = createEnum('NONE', 'SMALL', 'LARGE');
export const DISPLAY_TYPE = createEnum('ALL_PAGES', 'RULES_ONLY', 'DISABLED');
export const INITIAL_BUTTON_TYPES = createEnum('TEXT', 'ICON');
export const RULE_TYPES = createEnum('EXACT', 'CONTAINS', 'REGEX');
export const WIDGET_TYPES = createEnum('CHAT', 'SELF_SERVICE');
